/* SILNTPLAY reels: play muted loops only while on screen; strip arrows + drag.
   Posters: loops uploaded without one get a still from the same clip (map below). */
(function () {
  if (window.slReelsInit) return; window.slReelsInit = true;
  var F = 'https://cdn.shopify.com/s/files/1/0985/3045/9989/files/';
  var POSTERS = {
    aeaca88e8573474baa5e20028dd38a62: 'silntplay-web-emb-poster-1.jpg',
    '5be8b675df5747bb84451a1aba8d2db2': 'silntplay-web-emb-poster-2.jpg',
    '998be62e2e5847929c45f8571cbf2ccd': 'silntplay-web-emb-poster-3.jpg',
    '70972354c16043e68c6b4cb58d279d1c': 'silntplay-web-emb-poster-4.jpg',
    a1406db246eb476ea9f353a2772373d1: 'silntplay-web-emb-poster-5.jpg',
    '1c7de743cd644abbb9cc3f7fdd36398a': 'silntplay-web-emb-poster-6.jpg',
    '0c0054ac980e4369b02f94e54ff06fe0': 'silntplay-web-emb-poster-7.jpg',
    '6bf03c6a5c774578bae200433148f62e': 'silntplay-web-emb-poster-8.jpg',
    '4cd198204d37410bb4e8051066139d5f': 'silntplay-web-street-poster.jpg',
    aee883115a2f44a9809f3ceb18d3d1e4: 'silntplay-web-street-poster-graded.jpg'
  };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function posters() {
    document.querySelectorAll('video[data-sl-reel]').forEach(function (v) {
      if (v.getAttribute('poster')) return;
      var m = (v.getAttribute('data-src') || '').match(/\/vp\/([0-9a-f]{32})\//);
      var p = m && POSTERS[m[1]]; if (!p) return;
      var url = F + p + '?width=900';
      v.setAttribute('poster', url);
      if (v.parentElement && !v.parentElement.style.backgroundImage) v.parentElement.style.backgroundImage = "url('" + url + "')";
    });
  }
  function arm(v) {
    if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); v.preload = 'auto'; v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true }); }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function scan() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (e.isIntersecting && v.offsetParent !== null) arm(v); else if (!v.paused) v.pause(); });
    }, { rootMargin: '150px 150px' });
    document.querySelectorAll('video[data-sl-reel]').forEach(function (v) { io.observe(v); });
  }
  function strips() {
    document.querySelectorAll('[data-sl-strip]').forEach(function (s) {
      var t = s.querySelector('.sl-strip__track'); if (!t) return;
      s.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: Number(b.getAttribute('data-dir')) * t.clientWidth * 0.8, behavior: 'smooth' }); }); });
      var down = false, x0 = 0, s0 = 0, moved = false;
      t.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = t.scrollLeft; t.style.scrollSnapType = 'none'; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) moved = true; t.scrollLeft = s0 - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; t.style.scrollSnapType = ''; });
      t.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }
  function init() { posters(); scan(); strips(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
